import { render, staticRenderFns } from "./ApiDocs.vue?vue&type=template&id=8ee127cc"
import script from "./ApiDocs.vue?vue&type=script&lang=js"
export * from "./ApiDocs.vue?vue&type=script&lang=js"
import style0 from "./ApiDocs.vue?vue&type=style&index=0&id=8ee127cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports